import React from 'react';
import './Footer.css';
import {
  FaPhoneAlt,
  FaGlobe,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from 'react-icons/fa';
import { Link, NavLink } from 'react-router-dom';

const FooterCard = () => {
  return (
    <footer className="footer-card">

<div className="footer-right">
        <div className="profile-pic">
       <NavLink to={'/'}><img src="/logo1.png" width='60px' alt="StreamPlay Network"  /></NavLink> 
        </div>
      </div>
      

      <div className="footer-center">
       
        <div className="footer-links">
          
          <Link to="/privacy-policy">Privacy Policy</Link> &nbsp; 
          <Link to="/TermsAndConditions">Terms & Conditions</Link> <br/>
          <Link to="/AboutUs">About Us</Link> &nbsp;
          <Link to="/ContactUs">Contact Us</Link>
        </div>
        <br/> <br/>
        <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} StreamPlay Network | All Rights Reserved</p>
      </div>
      </div>

      <div className="footer-left">
        <h3>StreamPlay Network</h3>
        <NavLink></NavLink>
        <ul>

          <li><FaEnvelope />   <a href="mailto:info@treamplaynetwork.com">info@treamplaynetwork.com</a></li>
          <li> <FaFacebookF className="icon" />
            <a href="https://www.facebook.com/streamplaynetwork" target="_blank" rel="noopener noreferrer">www.facebook.com/streamplaynetwork</a></li>
          <li> <FaYoutube className="icon" />
            <a href="https://www.youtube.com/@STREAMPLAYNETWORK" target="_blank" rel="noopener noreferrer">www.youtube.com/@STREAMPLAYNETWORK</a></li>

        </ul>
      </div>

      
    </footer>
  );
};

export default FooterCard;
